export function hasContact({
  firstName,
  lastName,
  phone,
}: {
  firstName: string
  lastName: string
  phone: string
}) {
  return firstName.length > 0 && lastName.length > 0 && phone.length > 0
}
